import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_COMMENT_LIST = "GET_COMMENT_LIST";

export const service = async (data) => {  
  data.entityType="Denial Predictor";
  data.hasCommentUpdateAccess=true;
  const options: object = {
    url: "/Api/Comments/GetComments",
    method: "POST",
    headers: {
      "Content-Type": "application/json",},
    body: JSON.stringify(data),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_COMMENT_LIST, service, mock);
